/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ sku: NonNullable<unknown>, name: NonNullable<unknown> }} Error_Sku_Exists_ActiveInputs */

const vi_error_sku_exists_active = /** @type {(inputs: Error_Sku_Exists_ActiveInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mã hàng ${i?.sku} đã dùng cho sản phẩm "${i?.name}". Hãy đặt mã hàng khác.`)
};

/**

* @param {Error_Sku_Exists_ActiveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_sku_exists_active = /** @type {((inputs: Error_Sku_Exists_ActiveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Sku_Exists_ActiveInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_sku_exists_active(inputs)
});